export default function VerticalLink(vertical) {
  switch (vertical) {
    case 'knowyourvalue':
      return 'know-your-value';
    case 'news':
    case 'today':
    case 'msnbc':
    case 'noticias':
      return '';
    default:
      return vertical;
  }
}
